<template>
    <by-effect>
        <template v-slot:header>
            <img src="../../../assets/images/doctor/by-effects/radiation-therapy.png" alt="effect image">
        </template>

        <template v-slot:content>
            <p>Виявлено в анамнезі:</p>
            <p><strong>Променева терапія грудної клітки в минулому</strong></p>
        </template>
    </by-effect>
</template>

<script>
import ByEffect from './ByEffect';

export default {
    components : {
        'by-effect' : ByEffect
    }
}
</script>